import type { SupportedGame } from '@/config/supportedGames';
import type { BlogCategory } from '@/constants/blog.const';

export function getBlogPath(
  parts?:
    | { blogCategory: BlogCategory }
    | { slug: string; blogCategory: BlogCategory }
): string {
  const base = '/blog';
  if (!parts) {
    return base;
  }
  if ('slug' in parts) {
    return `${base}/${parts.blogCategory}/${parts.slug}`;
  }
  return `${base}/${parts.blogCategory}`;
}

export function getTournamentPath(
  parts?:
    | {
        slug: string;
        game: SupportedGame;
      }
    | {
        game: SupportedGame;
      }
): string {
  const base = '/pickems/tournaments';
  if (!parts) {
    return base;
  }

  const baseWithGame = `/${parts.game}${base}`;

  if ('slug' in parts) {
    return `${baseWithGame}/${parts.slug}`;
  }

  return baseWithGame;
}
